import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';

import Coaches from '../components/pick-your-coach/Coaches/Coaches';
import OnboardingCoaches from '../components/new-onboarding/Coaches/Coaches';
import Information from '../components/pick-your-coach/Information/Information';
import ChangeCoachModal from '../components/new-booking/components/changingCoach/ChangeCoachModal';

import styles from '../style/containers/PickYourCoach.module.scss';

import { ReactComponent as IconLeftArrow } from '../assets/icons/icon_left-arrow.svg';

// Import the invitation action
import { fetchInvitationDetails } from '../actions/invitation';

const PickYourCoach = ({ openChangeCoachModal, isMYC, invitationDetails, fetchInvitationDetailsAction, isLoadingInvitationDetails, user }) => {
  const informationRef = useRef(null);
  const history = useHistory();

  // Fetch invitation details when component mounts
  useEffect(() => {
    if (user?.invitation_id && !invitationDetails && !isLoadingInvitationDetails) {
      fetchInvitationDetailsAction(user?.invitation_id);
    }
  }, [invitationDetails, isLoadingInvitationDetails, fetchInvitationDetailsAction]);

  return (
    <div className={styles.wrapper}>
      <button className={styles['back']} onClick={() => history.goBack()}>
        <IconLeftArrow /> <span>Back</span>
      </button>
      {isMYC ? <OnboardingCoaches /> : <Coaches informationRef={informationRef} />}
      {!isMYC && <Information componentRef={informationRef} />}
      {openChangeCoachModal && <ChangeCoachModal redirectTo="/bookings" />}
    </div>
  );
};

const mapStateToProps = (state) => ({
  openChangeCoachModal: state.changeCoach.openChangeCoachModal,
  isMYC: state.changeCoach.isMYC,
  invitationDetails: state.invitation.details,
  isLoadingInvitationDetails: state.invitation.isLoading,
  user: state.user
});

PickYourCoach.defaultProps = {
  isMYC: false
};

PickYourCoach.propTypes = {
  openChangeCoachModal: PropTypes.bool.isRequired,
  isMYC: PropTypes.bool,
  invitationDetails: PropTypes.object,
  fetchInvitationDetailsAction: PropTypes.func.isRequired,
  isLoadingInvitationDetails: PropTypes.bool.isRequired,
  user: PropTypes.object.isRequired
};

export default connect(mapStateToProps, {
  fetchInvitationDetailsAction: fetchInvitationDetails
})(PickYourCoach);
